module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAMdJREFUOE+tU0sSgjAMffEEciLhSDLugb3DldATwQU0ThlL0yTtuLBLHn2f5JXgndva4kUDCO0OMx4gfmJuRv07mfvXbTkuGpAnTZIT9OsI0OC6Oj7mJIkg2H7Tkl0O1sOJUSJ44g73ZscSgVEXShr7iWA+q3gbJ3eJvOxAqKDirj4D8ASmi92K5yD4q65QjFfE++Mao0Avh+U0Qg3XNtHrQ6FEeQ+kmDsLW+MyQUB0FN2Lr6CNEJ1kUXz1uoPdRXhcgPeMo84HPJxhEXkXLAMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pos.png
// module id = nJ+d
// module chunks = 21